<template>
  <b-list-group-item>
    <b-row>
      <b-col cols="12" class="text-right">
        <b-button
          v-if="this.IsReadOnly === false && this.IsAdminEdit === true"
          class="col-2 ml-1"
          variant="outline-primary"
          @click="onEditBtnClicked"
          >แก้ไข</b-button
        >
        <b-button
          v-if="
            this.IsReadOnly === false &&
              IsDeleteAble === true &&
              AllowDelete === true
          "
          class="col-2 ml-1"
          variant="danger"
          @click="onDeletedBtnClicked"
          >ลบ</b-button
        >
      </b-col>

      <b-col cols="12" md="6">
        <b-form-group
          v-if="person.isOversea === false"
          label="เลขบัตรประจำตัวประชาชน"
          label-cols-md="5"
        >
          <span class="row col-form-label" v-text="': ' + person.identityId" />
        </b-form-group>
        <b-form-group
          v-if="person.isOversea === true"
          label="Passport"
          label-cols-md="5"
        >
          <span class="row col-form-label" v-text="': ' + person.identityId" />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="ชื่อ-นามสกุล" label-cols-md="5">
          <span class="row col-form-label" v-text="': ' + this.fullName" />
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <b-form-group label="วัน เดือน ปีเกิด" label-cols-md="5">
          <span
            class="row col-form-label"
            v-text="': ' + person.birthDateStr"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="อายุ" label-cols-md="5">
          <span class="row col-form-label" v-text="': ' + person.age" />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="เพศ" label-cols-md="5">
          <span class="row col-form-label" v-text="': ' + this.sexLabel" />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="" label-cols-md="5">
          <span class="row col-form-label" v-text="person.overseaLabel" />
        </b-form-group>
      </b-col>
      <b-col v-if="person.isOversea === true" cols="12" md="6">
        <b-form-group label="สัญชาติ" label-cols-md="5">
          <span
            class="row col-form-label"
            v-text="': ' + person.nationalityText"
          />
        </b-form-group>
      </b-col>
      <b-col v-if="person.isOversea === true" cols="12" md="6">
        <b-form-group label="เชื้อชาติ" label-cols-md="5">
          <span
            class="row col-form-label"
            v-text="': ' + person.ethnicityText"
          />
        </b-form-group>
      </b-col>

      <b-col cols="12" class="mt-1">
        <b-form-group label="ที่อยู่ตามบัตรประชาชน" label-cols-md="12">
          <!-- <span class="row col-form-label" v-text="this.fullAddressCitizenCard" /> -->
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="ที่อยู่" label-cols-md="5">
          <span
            class="row col-form-label"
            v-text="
              ': ' + person.cardAddress1 !== null ? person.cardAddress1 : ''
            "
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="" label-cols-md="5">
          <span class="row col-form-label" v-text="''" />
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <b-form-group label="ตำบล/แขวง" label-cols-md="5">
          <span
            class="row col-form-label"
            v-text="': ' + person.cardTumbon !== null ? person.cardTumbon : ''"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="อำเภอ/เขต" label-cols-md="5">
          <span
            class="row col-form-label"
            v-text="': ' + person.cardAmpher !== null ? person.cardAmpher : ''"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="จังหวัด" label-cols-md="5">
          <span
            class="row col-form-label"
            v-text="
              ': ' + person.cardProvince !== null ? person.cardProvince : ''
            "
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="รหัสไปรษณีย์" label-cols-md="5">
          <span
            class="row col-form-label"
            v-text="
              ': ' + person.cardZipcode !== null ? person.cardZipcode : ''
            "
          />
        </b-form-group>
      </b-col>

      <b-col cols="12" class="mt-1">
        <b-form-group
          label="ที่อยู่ปัจจุบันที่สามารถติดต่อได้"
          label-cols-md="12"
        >
          <!-- <span class="row col-form-label" v-text="this.fullAddress" /> -->
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="ที่อยู่" label-cols-md="5">
          <span
            class="row col-form-label"
            v-text="': ' + person.address1 !== null ? person.address1 : ''"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="" label-cols-md="5">
          <span class="row col-form-label" v-text="''" />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="ตำบล/แขวง" label-cols-md="5">
          <span
            class="row col-form-label"
            v-text="': ' + person.tumbon !== null ? person.tumbon : ''"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="อำเภอ/เขต" label-cols-md="5">
          <span
            class="row col-form-label"
            v-text="': ' + person.ampher !== null ? person.ampher : ''"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="จังหวัด" label-cols-md="5">
          <span
            class="row col-form-label"
            v-text="': ' + person.province !== null ? person.province : ''"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group label="รหัสไปรษณีย์" label-cols-md="5">
          <span
            class="row col-form-label"
            v-text="': ' + person.zipcode !== null ? person.zipcode : ''"
          />
        </b-form-group>
      </b-col>

      <b-col cols="12" class="mt-1">
        <b-form-group label="ข้อมูลติดต่อ" label-cols-md="12">
          <!-- <span class="row col-form-label" v-text="this.fullAddress" /> -->
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <b-form-group label="โทรศัพท์มือถือ" label-cols-md="5">
          <span class="row col-form-label" v-text="':' + person.tel" />
        </b-form-group>
      </b-col>

      <!-- <b-col cols="12" md="6">
        <b-form-group label="แฟกซ์" label-cols-md="5">
          <span class="row col-form-label" v-text="': '+person.fax" />
        </b-form-group>
      </b-col> -->

      <b-col cols="12" md="6">
        <b-form-group label="อีเมล" label-cols-md="5">
          <span class="row col-form-label " v-text="':' + person.email" />
        </b-form-group>
      </b-col>

      <b-col v-if="person.isOversea === true" cols="12" md="6">
        <b-form-group label="ที่อยู่ในต่างประเทศ" label-cols-md="6">
          <span
            class="row col-form-label"
            v-text="': ' + this.overseaAddress"
          />
        </b-form-group>
      </b-col>

      <b-col v-if="person.isOversea === true" cols="12" md="6">
        <b-form-group label="เบอร์โทรต่างประเทศ" label-cols-md="6">
          <span class="row col-form-label" v-text="': ' + this.overseaTel" />
        </b-form-group>
      </b-col>

      <b-col
        cols="12"
        md="6"
        v-for="item in person.contacts"
        :key="item.contactId"
      >
        <b-form-group
          :label="contactDescription(item.contactTypeId)"
          label-cols-md="5"
        >
          <span class="row col-form-label " v-text="':' + item.description" />
        </b-form-group>
      </b-col>

      <!-- <b-col
        cols="12"
        md="6"
        
        v-for="item in person.contacts"
        :key="item.contactId"
      >
        <b-form-group
          :label="contactTypeLabel(item.contactTypeId)"
          label-cols-md="6"
        >
          <span class="row col-form-label " v-text="':xxx '+item.description" />
        </b-form-group>
      </b-col> -->
    </b-row>
  </b-list-group-item>
</template>

<script>
import {
  BFormGroup,
  BRow,
  BCol,
  BFormInput,
  BListGroup,
  BListGroupItem,
  BButton,
} from "bootstrap-vue";

import * as masterStore from "@/store/api/master/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import appsetting from "@/store/app-settings/index.js";

export default {
  components: {
    BButton,
    BFormGroup,
    BRow,
    BCol,
    BFormInput,
    BListGroup,
    BListGroupItem,
  },
  props: {
    person: {
      type: Object,
      required: true,
    },
    IsReadOnly: false,
    IsDeleteAble: false,
    AllowDelete: true,
  },
  setup(props) {
    console.log("props.person", props.person);
    return {
      ReadOnly: props.IsReadOnly,
    };
  },
  created() {
    this.getContactTypeMaster();
  },
  data() {
    return {
      contactTypes: [],
      EditUserRole: null,
      IsAdminEdit: false,
    };
  },
  mounted() {
    const GetRole = userData.selectedRole();
    this.EditUserRole = GetRole.toLowerCase();
    // console.log('this.EditUserRole', this.EditUserRole);

    if(appsetting.complaintRoleId.admin === this.EditUserRole){
      this.IsAdminEdit = true;
    }
    // console.log('appsetting.complaintRoleId.admin', appsetting.complaintRoleId.admin);
    // console.log('IsAdminEdit', this.IsAdminEdit);
  },
  methods: {
    onDeletedBtnClicked() {
      this.$emit("handle-deleted-personal", this.person.userId);
    },
    onEditBtnClicked() {
      // console.log("readony", this.IsReadOnly);
            this.$emit("handle-edit-personal", this.person.userId);
    },
    contactTypeLabel(id) {
      console.log("contactTypeLabel");
      if (id === 1) {
        return "เบอร์โทรศัพท์มือถือ";
      } else if (id === 2) {
        return "อีเมล";
      } else if (id === 3) {
        return "โทรสาร";
      } else if (id === 4) {
        return "Line ID";
      } else if (id === 5) {
        return "เบอร์โทรศัพท์";
      } else {
        return "อื่นๆ";
      }
    },
    getContactTypeMaster() {
      const _this = this;
      masterStore.getDigitalIdContactType().then((response) => {
        _this.contactTypes = response.data.data;
      });
    },
    contactDescription(id) {
      if (
        this.contactTypes == undefined ||
        this.contactTypes == null ||
        this.contactTypes.length == 0
      ) {
        return "";
      }

      const currentContact = this.contactTypes.find((value) => {
        return value.value == id;
      });

      console.log("currentContact", currentContact, this.contactTypes, id);

      return currentContact.text;
    },
  },
  computed: {
    fullName() {
      return [
        this.person?.titleDesc,
        this.person?.fName,
        this.person?.mName,
        this.person?.lName,
      ]
        .filter(Boolean)
        .join(" ");
    },
    fullAddressCitizenCard() {
      return [
        this.person?.cardAddress1,
        this.person?.cardAddress2,
        this.person?.cardTumbon,
        this.person?.cardAmpher,
        this.person?.cardProvince,
        this.person?.cardZipcode,
      ]
        .filter(Boolean)
        .join(" ");
    },
    fullAddress() {
      return [
        this.person?.address1,
        this.person?.address2,
        this.person?.tumbon,
        this.person?.ampher,
        this.person?.province,
        this.person?.zipcode,
      ]
        .filter(Boolean)
        .join(" ");
    },
    sexLabel() {
      return this.person?.sex === "m" ? "ชาย" : "หญิง";
    },
    overseaLabel() {
      return this.person?.isOversea === true ? "ชาวต่างชาติ" : "ชาวไทย";
    },
    overseaAddress() {
      return [
        this.person?.oSAddress1,
        this.person?.oSAddress2,
        this.person?.city,
        this.person?.prefecture,
        this.person?.country,
        this.person?.postalCode,
      ]
        .filter(Boolean)
        .join(" ");
    },
    overseaTel() {
      return [this.person?.telPrefix, this.person?.oSTel, this.person?.telExt]
        .filter(Boolean)
        .join(" ");
    },
  },
};
</script>

<style>
.form-group {
  margin-bottom: 0rem;
}
.list-group-item {
  padding: 0.5rem;
}

.list-group-item {
  padding: 0.5rem;
}

.card-body {
  padding: 0.75rem;
}
</style>
